

import axios from 'axios';
import React, { useRef } from 'react'
import { useEffect, useState } from 'react'
import { BASE_URL } from '../../config/axios';
import Dashboardnavbar from '../../layout/Dashboardnavbar';
import { AddConsultant, DeleteConslutant, UpdateConsultant } from './ConsultantCrud';
import WorkStat from './WorkStat';


const Consultant = ({ getData, list, buffering, workTypeList }) => {
    const tableRef = useRef(null);


    return (
        <div className='table-css-white-background' style={{ width: "100%" }}>
            <div className="table-box paddingTop-0px scroll-container-table" style={{ height: "70vh" }}>
                <table ref={tableRef} style={{ width: "100%" }} className="table-css">
                    <thead className="table-heading">
                        <tr className="custom-table-head-tr">
                            <th className="table-heading-text text-start" style={{ width: "70px" }}>S.No.</th>
                            <th className="table-heading-text text-start">Name</th>
                            <th className="table-heading-text text-end" style={{ width: "110px" }}>Action</th>
                        </tr>
                    </thead>
                    {buffering ? (
                        <tbody>
                            <tr>
                                <td colSpan={3}>
                                    <div className="spinner-bgdatil"></div>
                                </td>
                            </tr>
                        </tbody>
                    ) : (
                        <tbody>
                            {list
                                ?.sort((a, b) => a.name.localeCompare(b.name))
                                .map((i, index) => (
                                    <tr key={i.id || index} className="custom-table-head-td">
                                        <td className="table-body text-start" style={{ width: "70px" }}>{index + 1}.</td>
                                        <td className="table-body text-start">{i.name || "-"}</td>
                                        <td className="table-body text-end" style={{ width: "110px" }}>
                                            <UpdateConsultant getSubConsultant={getData} workTypeList={workTypeList} i={i} />
                                            <DeleteConslutant getSubConsultant={getData} i={i} />
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    )}
                </table>
            </div>
        </div>
    );
}

export default Consultant;